module.exports = __webpack_public_path__ + "static/media/sketch-street-glide-special.db13c2a2.png";